import * as React from 'react';
export const CustomHeaderContext = React.createContext(null);
export const CustomHeaderContextProvider = CustomHeaderContext.Provider;
export const CustomHeaderContextConsumer = CustomHeaderContext.Consumer;
